import type { Pet, PetAttribute, PetStatusEffect } from '.';

import { SB } from '@play-co/replicant';
import { tuple } from '../../utils/types';

export const petSchema = (Pet: Pick<Pet, 'ruleset'>) => {
  type AttributeSchema = typeof attributeSchema;
  type StatusEffectSchema = typeof statusEffectSchema;

  const { attributeBounds, species, evolutionSequence } = Pet.ruleset;
  const attributeSchema = SB.object({
    value: SB.number().min(attributeBounds.min).max(attributeBounds.max),
    lastUpdatedAt: SB.number(),
  });

  const statusEffectSchema = SB.object({
    value: SB.boolean(),
    lastUpdatedAt: SB.number(),
    resolutionAttempts: SB.number().default(0),
  });

  return {
    petRaised: SB.number(),
    highestPetAge: SB.number(),
    pet: SB.object({
      name: SB.string(),

      evolutions: SB.array(
        SB.object({
          species: SB.tuple(tuple(...species)),
          stage: SB.tuple(evolutionSequence),
          timestamp: SB.number(),
        }),
      ),
      attributes: SB.object(
        Pet.ruleset.petAttributes.reduce(
          (schema, attribute) => ({
            ...schema,
            [attribute]: attributeSchema,
          }),
          {} as Record<PetAttribute, AttributeSchema>,
        ),
      ),
      statusEffects: SB.object(
        Pet.ruleset.petStatusEffects.reduce(
          (schema, effect) => ({
            ...schema,
            [effect]: statusEffectSchema,
          }),
          {} as Record<PetStatusEffect, StatusEffectSchema>,
        ),
      ),
    }),
  };
};
